import { render, staticRenderFns } from "./prompt-wrapper.vue?vue&type=template&id=17d22bbd&scoped=true"
import script from "./prompt-wrapper.vue?vue&type=script&lang=js"
export * from "./prompt-wrapper.vue?vue&type=script&lang=js"
import style0 from "./prompt-wrapper.vue?vue&type=style&index=0&id=17d22bbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d22bbd",
  null
  
)

export default component.exports